import React, { useState, useEffect, useReducer } from 'react';
import { Button } from 'zarm';
import classname from 'classnames';
import { Upload, Toast } from '@iyunbao/components';

import PopupBottom from '../../../popupBottom';
import fetchAPI from '../../../utils/fetchAPI';
import { deepCopy, mergeObj } from '../../../utils/tools';
import config from '../../../config';

import {
  certUploadPage,
  requestUploadOCR,
} from '../_util';

export interface AddressBookProps {
  prefixCls?: string;
  visible: boolean;
  className?: string;
  onClose?: () => void;
  onChange?: (item: any) => void;
  onLog?: (name: string) => void;
}

export interface ICertUploadState {
  id: string | number;
  title: string;
  type: string;
  errorCode: number;
  message: string;
  // front: 'front' | 'back';
  src: string;
  base64?: string;
  fileId?: string;
}

/**
 * 通讯录UI
 * @param props
 */
function ImageOCR(props: AddressBookProps) {
  const {
    prefixCls = 'crm-address-book-orc',
    className,
    visible,
    onClose,
    onChange,
  } = props;
  const [data, setData] = useState<ICertUploadState[]>(deepCopy(certUploadPage));
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [ocrResult, setOcrResult] = useState({});
  const [checkToken, setCheckToken] = useState('');

  const cls = classname(prefixCls, className);

  useEffect(() => {
    const params = {
      url: `${config.iybtm.host}/util/token.json`,
      method: 'get',
    };

    fetchAPI
      .fetchResult(params)
      .then(({ code, result }) => {
        if (code === 0 && result) {
          setCheckToken(result);
        }
      })
      .catch((message: string) => {
        if (typeof message === 'string') {
          Toast.warning(message);
        }
      });
  }, []);

  // 证件上传
  function onChangeValue(file, item) {
    requestUploadOCR({
      checkToken,
      idCardSide: item.front,
      imageBase64: file.thumbnail,
    })
      .then((result: any) => {
        const { bizNo, idCardSide, url, ...rest } = result || {};
        const dItem = data.filter((vItem) => vItem.id === item.id);

        if (dItem && Array.isArray(dItem) && dItem.length) {
          dItem[0].base64 = file.thumbnail;
          dItem[0].type = 'add';
          dItem[0].errorCode = 1;
          dItem[0].fileId = bizNo;
        }

        setData(data);
        setOcrResult(mergeObj(ocrResult, rest));
        // 强制更新
        forceUpdate();
      })
      .catch((message) => {
        const dItem = data.filter((vItem) => vItem.id === item.id);

        if (dItem && Array.isArray(dItem) && dItem.length) {
          dItem[0].type = 'fail';
          dItem[0].errorCode = 2;
          dItem[0].message = (message || '系统异常');
        }

        setData(data);
        // 强制更新
        forceUpdate();
      });
  }

  function onOk() {
    const len = data.length;
    let errorCount = 0;
    let selectCount = 0;

    if (data && Array.isArray(data) && data.length) {
      data.forEach((item) => {
        // 证件上传错误
        if (item.type === 'fail') {
          errorCount += 1;
        }

        if (item.fileId) {
          selectCount += 1;
        }
      });
    }

    if (selectCount < len) {
      Toast.warning('请选择证件');
      return false;
    }

    if (errorCount) {
      Toast.warning('证件错误，请重新上传');
      return false;
    }

    onChange && onChange(ocrResult);
  }

  const itemNode = () => {
    if (data && Array.isArray(data) && data.length) {
      return data.map((item, key) => (
        <div className={`${prefixCls}-list`} key={`item_${item.id || key}`}>
          <Upload
            onChange={(file) => onChangeValue(file, item)}
            quality={0.8}
          />
          <img src={item.base64 ? item.base64 : item.src} alt={item.title} />
          {
            !item.base64 && (
              <div className={`${prefixCls}-center`}>
                <div className="button-upload" key="upload" />
                <div className="cert-name" key="name">{item.title}</div>
              </div>
            )
          }
          {
            item.type === 'fail' && (
              <div className="upload-fail">
                <div className="upload-fail-inner">
                  <div className="icons-fail" />
                  <div className="fail-name">{ (item.errorCode !== 1) ? item.message : '识别失败，请重新上传' }</div>
                </div>
              </div>
            )
          }
        </div>
      ));
    }

    return null;
  };

  return (
    <PopupBottom
      visible={visible}
      title="快速识别身份信息"
      className={cls}
      footer={(
        <div className="button-item">
          <Button
            block
            shape="round"
            theme="primary"
            className="button-confirm"
            onClick={() => onOk()}
          >
            确定
          </Button>
        </div>
      )}
      onClose={() => onClose && onClose()}
    >
      <div className={`${prefixCls}-desc`}>
        请上传身份证照，帮助您快速录入身份信息
      </div>
      {itemNode()}
    </PopupBottom>
  );
}

export default ImageOCR;
